export const LAST_UPDATED_TODAY = 'today';

export const BIG_AREA_CODES = ['RU', 'US', 'FR'];
export const ERRORS_TO_SAVE_TO_STORE = ['empty_area', 'too_big_area', 'polygon_length_greater_360', 'ru_only_product'];
